export default __webpack_public_path__ + "static/media/11_2B2609R-min.ec9663ef.jpg";